import {
  ResponsiveContainer,
  LineChart,
  XAxis,
  YAxis,
  Line,
  Tooltip,
} from "recharts";
import { numberFormatter, formatWithCommas } from "../../../utils/formatter";
import { useEffect, useState } from "react";

type Props = {
  data: Record<string, any>[];
  name: string;
  years: string;
  unit: string;
  decimal: number;
  selectedType: any;
  lastMonth: any;
  setLastMonth: React.Dispatch<any>;
};

export default function LineChartReports({
  data,
  name,
  unit = "",
  years = "",
  decimal = 0,
  selectedType,
  lastMonth,
  setLastMonth,
}: Props) {
  const getCenteredTrianglePoints = (
    x: any,
    y: any,
    base: any,
    height: any
  ) => {
    return [
      `${x},${y - height}`, // Top
      `${x + base / 2},${y + height}`, // Bottom Right
      `${x - base / 2},${y + height}`, // Bottom Left
    ].join(" ");
  };
  const findLastNonNullMonthWithFilter = (data: any) => {
    // Find the highest year key
    if (selectedType === "Weekly") return null;
    else {
      const highestYear = years[1];

      // Filter for entries where the value for the highest year is not null
      const nonNullEntries = [
        ...data.filter(
          (item: any) =>
            item[highestYear] !== null && item[highestYear] !== undefined
        ),
      ];

      // Get the last entry in the filtered array
      if (nonNullEntries.length === 0) return null;
      return nonNullEntries[nonNullEntries.length - 1].month;
    }
  };

  useEffect(() => {
    if (data) {
      setLastMonth(findLastNonNullMonthWithFilter(data));
    }
  }, [data]);

  return (
    <div className="shadow-module-card bg-white h-full">
      <div className="font-bold pl-[1.2vh] pt-[1.2vh] pb-[0.5vh] text-[1.9vh]">
        {name}
      </div>
      <div className="flex">
        <div
          className={`flex items-center ml-[6vh] ${
            selectedType === "Weekly" && "hidden"
          }`}
        >
          <div className="h-[0.5vh] w-[6vh] bg-[#86BC25] rounded-[1vh] mr-[0.5vh]"></div>
          <div className="text-[1.6vh]">{years[0]}</div>
        </div>
        {(selectedType === "Weekly" || years[1]) && (
          <div className="flex items-center ml-[3vh]">
            <div className="h-[0.5vh] w-[6vh] bg-[#213396] rounded-[1vh] mr-[0.5vh]"></div>
            <div className="text-[1.6vh]">
              {selectedType === "Weekly" ? years[0] : years[1]}
            </div>
          </div>
        )}
      </div>
      <div className="h-[88%] w-full">
        <ResponsiveContainer height="92%">
          <LineChart style={{ padding: "1vh 1vh 1vh 0vh" }} data={data}>
            <XAxis clip={"none"} interval={0} dataKey="month" />
            <YAxis
              tickFormatter={(value) => {
                return numberFormatter(value, 1, unit);
              }}
            />
            <Tooltip
              formatter={(value: any) => {
                return formatWithCommas(
                  parseFloat(value)?.toFixed(decimal)?.toString()
                );
              }}
            />
            {selectedType !== "Weekly" && (
              <Line
                type="linear"
                dataKey={years[0]}
                stroke="#86BC25"
                // dot={{ r: 2.2, fill: "#86BC25" }}
                dot={(props: any) => {
                  const { cx, cy, payload } = props;
                  const color = "#86BC25";
                  return <circle cx={cx} cy={cy} r={2.2} fill={color} />;
                }}
                // activeDot={{ r: 4, fill: "#86BC25" }}
                activeDot={(props: any) => {
                  const { cx, cy, payload } = props;
                  const color = "#86BC25";
                  return <circle cx={cx} cy={cy} r={2.2} fill={color} />;
                }}
              />
            )}

            <Line
              type="linear"
              dataKey={selectedType === "Weekly" ? years[0] : years[1]}
              stroke="#213396"
              // dot={{ r: 2.2, fill: "#213396" }}
              dot={(props: any) => {
                const { cx, cy, payload } = props;
                const color = "#213396";
                return selectedType === "Weekly" ? (
                  <circle cx={cx} cy={cy} r={2.2} fill={color} />
                ) : payload[years[1]] ? (
                  lastMonth === payload.month ? (
                    // <svg
                    //   width="20"
                    //   height="20"
                    //   x={cx - 10}
                    //   y={cy - 10}
                    //   xmlns="http://www.w3.org/2000/svg"
                    // >
                    //   <polygon
                    //     points={getCenteredTrianglePoints(10, 10, 6, 3)}
                    //     fill={color}
                    //     stroke={color}
                    //     stroke-width="1"
                    //   />
                    // </svg>
                    <circle
                      cx={cx}
                      cy={cy}
                      r={2.2}
                      fill="none"
                      stroke={color}
                      strokeWidth="2"
                    />
                  ) : (
                    <circle cx={cx} cy={cy} r={2.2} fill={color} />
                  )
                ) : (
                  <></>
                );
              }}
              // activeDot={{ r: 4, fill: "#213396" }}
              activeDot={(props: any) => {
                const { cx, cy, payload } = props;
                const color = "#213396";
                return selectedType === "Weekly" ? (
                  <circle cx={cx} cy={cy} r={2.2} fill={color} />
                ) : payload[years[1]] ? (
                  lastMonth === payload.month ? (
                    // <svg
                    //   width="20"
                    //   height="20"
                    //   x={cx - 10}
                    //   y={cy - 10}
                    //   xmlns="http://www.w3.org/2000/svg"
                    // >
                    //   <polygon
                    //     points={getCenteredTrianglePoints(10, 10, 6, 3)}
                    //     fill={color}
                    //     stroke={color}
                    //     stroke-width="1"
                    //   />
                    // </svg>
                    <circle
                      cx={cx}
                      cy={cy}
                      r={2.2}
                      fill="none"
                      stroke={color}
                      strokeWidth="2"
                    />
                  ) : (
                    <circle cx={cx} cy={cy} r={2.2} fill={color} />
                  )
                ) : (
                  <></>
                );
              }}
            />
          </LineChart>
        </ResponsiveContainer>
      </div>
    </div>
  );
}